import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
//import  Footer  from './Footer';
import loaderImage from '../images/loader.svg';
import NavHeader from './NavHeader';
import useLogout from '../api/useLogout';

const TraderLayout = ({ children }) => {
    const [zoomMessageVisible, setZoomMessageVisible] = useState(false);

    const logout = useLogout();
    

    const handleBeforeUnload = async (event) => {

        await logout();

        if (event.preventDefault) {
            event.preventDefault();
        }

        event.returnValue = 'logging out...';
    };

    const handleResize = () => {
        const zoomLevel = window.innerWidth / window.outerWidth;
        if (zoomLevel !== 1) {
            // Show message if zoom level is not 100%
            setZoomMessageVisible(true);
        } else {
            // Hide message if zoom level is 100%
            setZoomMessageVisible(false);
        }
    };

    //useEffect(() => {
    //    window.addEventListener('beforeunload', handleBeforeUnload);
    //    window.addEventListener('resize', handleResize);
    //    handleResize(); // Initial check for zoom level

    //    return () => {
    //        window.removeEventListener('beforeunload', handleBeforeUnload);
    //        window.removeEventListener('resize', handleResize);
    //    };
    //}, []);  

    return (
        <div className="ltr light-theme horizontalmenu-hover horizontalmenu color-menu header-light">
            <div className="horizontalMenucontainer">
                <div className="horizontalMenucontainer">
                    <div className="page">
                        <NavHeader />
                        <div className="jumps-prevent" style={{ paddingTop: '64.3333px', borderBottomWidth: '3px', borderColor: '#393186', borderBottomStyle: "solid" }}></div>
                        <div className="main-content pt-0 hor-content">
                            <div className="main-container container">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TraderLayout;
